module.exports = __webpack_public_path__ + "img/icon2-5.10c0cf03.svg";